"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TextButtonMixin = require("../../mixins/components/TextButtonMixin");
var StyledTextButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "StyledTextButton",
  componentId: "c11n-8-107-0__sc-1nwmfqo-0"
})(["", ""], _TextButtonMixin.TextButtonMixin);
exports.StyledTextButton = StyledTextButton;